var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('div',{staticClass:"text-center"},[_c('label',{staticClass:"mb-3",staticStyle:{"font-weight":"bold"},domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.display))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }